var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { generateAdjacentVolume, } from "../../api/periodicalIssueService";
import { invalidateVolumeViews, usePeriodicalVolumes, } from "../../hooks/usePeriodicalVolumes";
import { extractServerErrorMessage } from "../../utils/errorHandler";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { describeVolume, isVolumeOver, sortVolumesByStart, } from "../../utils/volumeWindow";
var MESSAGE_IDS = {
    first: {
        title: "ui-br-legaldeposits.periodicals.volume.generateFirst",
        body: "ui-br-legaldeposits.periodicals.volume.generate.bodyFirst",
        confirm: "ui-br-legaldeposits.periodicals.volume.generateFirst",
    },
    next: {
        title: "ui-br-legaldeposits.periodicals.volume.generateNext.title",
        body: "ui-br-legaldeposits.periodicals.volume.generateNext.body",
        confirm: "ui-br-legaldeposits.periodicals.volume.generateNext",
    },
    previous: {
        title: "ui-br-legaldeposits.periodicals.volume.generatePrevious.title",
        body: "ui-br-legaldeposits.periodicals.volume.generatePrevious.body",
        confirm: "ui-br-legaldeposits.periodicals.volume.generatePrevious",
    },
};
export var GenerateVolumeDialog = function (_a) {
    var _b;
    var open = _a.open, periodicalLibraryId = _a.periodicalLibraryId, direction = _a.direction, onClose = _a.onClose, onGenerated = _a.onGenerated;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _c = usePeriodicalVolumes(periodicalLibraryId, open), volumes = _c.data, isLoading = _c.isLoading;
    var edgeVolume = useMemo(function () {
        var sorted = sortVolumesByStart(volumes !== null && volumes !== void 0 ? volumes : []);
        return direction === "next" ? sorted[sorted.length - 1] : sorted[0];
    }, [volumes, direction]);
    var mutation = useMutation(function () { return generateAdjacentVolume(kyInstance, periodicalLibraryId, direction); }, {
        onSuccess: function (created) {
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
            onGenerated === null || onGenerated === void 0 ? void 0 : onGenerated(created);
        },
    });
    var reset = mutation.reset;
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    useEffect(function () {
        if (!open) {
            reset();
            setErrorMessage(null);
        }
    }, [open, reset]);
    var handleConfirm = useCallback(function () {
        setErrorMessage(null);
        mutation.mutate(undefined, {
            onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = setErrorMessage;
                            return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                                    id: "ui-br-legaldeposits.periodicals.volume.generate.error",
                                }))];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }, [mutation, formatMessage]);
    var created = mutation.data;
    var isFirst = created
        ? ((_b = volumes === null || volumes === void 0 ? void 0 : volumes.length) !== null && _b !== void 0 ? _b : 0) <= 1
        : !isLoading && !edgeVolume;
    var ids = MESSAGE_IDS[isFirst ? "first" : direction];
    var footer = (React.createElement(ModalFooter, null, created ? (React.createElement(Button, { buttonStyle: "primary", onClick: onClose }, formatMessage({ id: "ui-br-legaldeposits.common.close" }))) : (React.createElement(React.Fragment, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: isLoading || mutation.isLoading }, formatMessage({ id: ids.confirm })),
        React.createElement(Button, { onClick: onClose, disabled: mutation.isLoading }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))))));
    return (React.createElement(Modal, { open: open, onClose: onClose, dismissible: true, label: formatMessage({ id: ids.title }), footer: footer },
        created ? (React.createElement(MessageBanner, { type: "success" },
            formatMessage({ id: "ui-br-legaldeposits.periodicals.volume.generate.success" }, {
                volume: describeVolume(created),
                count: created.issueCount,
            }),
            isVolumeOver(created) && (React.createElement("p", null, formatMessage({
                id: "ui-br-legaldeposits.periodicals.volume.generate.ownLibraryOnly",
            }))))) : (React.createElement("p", null, !isLoading &&
            formatMessage({ id: ids.body }, { volume: edgeVolume ? describeVolume(edgeVolume) : "" }))),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage))));
};
